import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
export function Badge({ variant = 'neutral', dot = true, className, children, ...rest }) {
    return (_jsxs("span", { className: clsx('sterling-badge', `sterling-badge-${variant}`, className), ...rest, children: [dot && _jsx("span", { className: "sterling-badge-dot" }), children] }));
}
//# sourceMappingURL=Badge.js.map